$(document).ready(function () {
  $('.duo-feature-variant').on('click', function () {
    const blockEl = $(this).parents('.duo-feature-wrap')
    const className = $(this).attr('data-class')

    blockEl.removeClass('plus-active').removeClass('standard-active')
    blockEl.addClass(className)
  })
})
